import getSearchObj from '@/utils/getSearchObj';

const ua = window.navigator.userAgent;
const packageJson = require('../../package.json');
// import Tools from '@/utils/tools';

const versionCompare = (ver1, ver2) => {
  const v1 = ver1 || '0.0.0';
  const v2 = ver2 || '0.0.0';
  if (v1 === v2) {
    return 0;
  }
  const v1Arr = v1.split('.');
  const v2Arr = v2.split('.');
  const len = Math.max(v1Arr.length, v2Arr.length);
  for (let i = 0; i < len; i += 1) {
    const v1Item = Number(v1Arr[i] || 0);
    const v2Item = Number(v2Arr[i] || 0);
    if (v1Item < v2Item) {
      return -1;
    } if (v1Item > v2Item) {
      return 1;
    }
  }
  return 0;
};

// 判断ua为高铁管家
const isGaotieGuanjia = ua.toLowerCase().includes('gtgj');
// 判断ua为天府通
const isTianFuTong = ua.toLowerCase().includes('tft');

const env = {
  isBaiduMP: /swan-baiduboxapp/i.test(ua),
  isWeixin: /micromessenger/i.test(ua),
  isAndroid: /android/i.test(ua) || /OpenHarmony/i.test(ua),
  isHarmony: /OpenHarmony/i.test(ua),
  isAlipayClient: /AlipayClient/i.test(ua) && ua.indexOf('DingTalk') === -1,
  isAliMP: ua.indexOf('AlipayClient') > -1
      && (ua.indexOf('MiniProgram') > -1 || ua.indexOf('AlipayIDE') > -1)
      && ua.indexOf('DingTalk') === -1,
  isDingTalk: ua.indexOf('DingTalk') > -1,
  isIOS: /iPad|iPhone|iPod/.test(ua),
  isThirdParty: /wifiwx/i.test(ua) || !!window.HBJsBridge,
  isEasyBikeApp: false,
  isHitchIndepApp: false,
  // app版本号 oldversion为3.5.2(含)之前的版本
  // appVersion: APP_VERSION,
  appVersion: `${packageJson.version}`,
  isWeibo: /weibo/i.test(ua),
  isQQ: /QQ/.test(ua),
  isWeixinMp: '', // ! 异步设置
  isAliTrip: !!window.methodChannel,
  isChannelApp: !!window.methodChannel 
    || /OpenHarmony/i.test(ua) 
    || /unionpay/i.test(ua) 
    || !!window.saicpassenger 
    || /saic/i.test(ua)
    || ua.toLowerCase().includes('toutiaomicroapp')
    // 判断ua为高铁管家
    || isGaotieGuanjia
    // 判断是否为天府通
    || isTianFuTong,
  isUnionPay: /unionpay/i.test(ua),
  isRobotaxi: !!window.saicpassenger || /saic/i.test(ua),
  isGaotieGuanjia,
  isTianFuTong,
  isTT: ua.toLowerCase().includes('toutiaomicroapp'),
};

function extractApp() {
  const matches = ua.match(/\b\s*app=easybike(?:;\s*version=([\d.]+))*/i);
  const hitchIndepAppMatches = ua.match(/\b\s*app=hellohitch(?:;\s*version=([\d.]+))*/i);
  if (matches) {
    env.isEasyBikeApp = true;
    [, env.appVersion] = matches;
    if (!env.appVersion) {
      env.appVersion = '1.1.0';
    }
  }
  if (hitchIndepAppMatches) {
    env.isHitchIndepApp = true;
    [, env.appVersion] = hitchIndepAppMatches;
    if (!env.appVersion) {
      env.appVersion = '1.1.0';
    }
  }
}

extractApp();

env.platform = {
  os: 'other',
  app: 'browser',
};
if (env.isAndroid) {
  env.platform.os = 'Android';
} else if (env.isIOS) {
  env.platform.os = 'IOS';
}

if (env.isWeixin) {
  env.platform.app = 'wechat';
} else if (env.isEasyBikeApp) {
  env.platform.app = 'hellobike_app';
} else if (env.isAlipayClient) {
  env.platform.app = 'alipay';
} else if (env.isThirdParty) {
  env.platform.app = 'third_party_app';
} else if (env.isQQ) {
  env.platform.app = 'qq';
} else if (env.isWeibo) {
  env.platform.app = 'weibo';
} else if (env.isHitchIndepApp) {
  env.platform.app = 'hellohitch_app';
}

if (env.isEasyBikeApp && env.isIOS) {
  env.systemCode = '61';
} else if (env.isEasyBikeApp && env.isAndroid) {
  if (/OpenHarmony/i.test(ua)) {
    env.systemCode = '68';
  } else {
    env.systemCode = '62';
  }
  // env.systemCode = '62';
} else if (env.isHarmony) {
  env.systemCode = '68';
} else if (env.isHitchIndepApp && env.isIOS) {
  env.systemCode = 'sfc1';
} else if (env.isHitchIndepApp && env.isAndroid) {
  env.systemCode = 'sfc2';
} else if (env.isWeixin) {
  env.systemCode = '64';
} else if (env.isAlipayClient) {
  env.systemCode = '65';
} else {
  env.systemCode = '63';
}


env.platformCode = {
  browser: 1,
  wechat: 2,
  alipay: 3,
  hellobike_app: 4,
  third_party_app: 5,
  qq: 6,
  weibo: 7,
}[env.platform.app];

env.mpContainer = '';
env.wxHitchMpPathPrefix = '';
if (env.isWeixin) {
  const searchObj = getSearchObj();
  if (searchObj && searchObj.mp) {
    env.mpContainer = searchObj.mp;
    env.mpVersion = searchObj.mpVersion;
    if (env.mpContainer === 'hitch') {
      env.isWxHitchMp = true;
      env.isNewWxHitchMp = versionCompare(env.mpVersion, '5.64.0') >= 0;
      env.wxHitchMpPathPrefix = env.isNewWxHitchMp ? '/hitch/src' : '';
    }
  } else {
    env.mpContainer = 'platform';
  }
} else if (env.isAliMP) {
  const alipayObj = getSearchObj();
  if (alipayObj && alipayObj.mpVersion) {
    env.mpVersion = alipayObj.mpVersion;
  }
}

env.platform.bizVersion = `"${packageJson.version}"`;

env.codeEnv = process.env.VUE_APP_ENV || 'pro';
if (env.codeEnv === 'test') {
  env.codeEnv = 'dev';
}
env.cdnEnv = env.codeEnv === 'pro' ? '' : `${env.codeEnv}/`;

export default env;
